export default "__VITE_ASSET__C5B6NyPL__"